import { render, staticRenderFns } from "./MyInfoPasswordPop.vue?vue&type=template&id=45ec37d9"
import script from "./MyInfoPasswordPop.vue?vue&type=script&lang=js"
export * from "./MyInfoPasswordPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ec37d9')) {
      api.createRecord('45ec37d9', component.options)
    } else {
      api.reload('45ec37d9', component.options)
    }
    module.hot.accept("./MyInfoPasswordPop.vue?vue&type=template&id=45ec37d9", function () {
      api.rerender('45ec37d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/MyInfoPasswordPop.vue"
export default component.exports